import { useFormikContext } from 'formik';
import React from 'react';
import { SparkTextField, SparkDropdown } from 'sharedComponents/SparkForm';
import { DropdownOption } from 'types/common/DropdownOption';
import type { PrivacyInfoFormValues } from './PrivacyInfoForm';
import { Box, Divider, Grid } from '@mui/material';
import { InfoCard } from 'sharedComponents/UI';
import SectionHeader from '../SparkSectionHeader';
import SparkSectionHeader from '../SparkSectionHeader';

type Props = { isPublicSpark: boolean; billingOptions: DropdownOption[] };

function PrivacyInfoBillingContent({ isPublicSpark, billingOptions }: Props) {
  const { values } = useFormikContext<PrivacyInfoFormValues>();
  const { price } = values;
  if (!isPublicSpark) {
    return (
      <Box sx={{ width: '100%' }}>
        <Divider
          sx={{ width: '100%', marginBottom: '20px', marginTop: '20px' }}
        />
        <SectionHeader headerText='Pricing' />
        <InfoCard
          info={'Set Privacy to Public to enable Pricing'}
          cardStyles={{ maxHeight: '40px' }}
        />
      </Box>
    );
  }

  return (
    <>
      <Divider
        sx={{ width: '100%', marginBottom: '12px', marginTop: '20px' }}
      />
      <SparkSectionHeader headerText='Pricing' />
      <Grid container item spacing={1}>
        <SparkTextField
          name='price'
          label='Price'
          placeholder='Free'
          type='number'
          size={6}
          sx={{ '& .MuiInputBase-adornedStart': { paddingLeft: 0 } }}
          startAdornment={
            <Box
              height='100%'
              display='flex'
              justifyContent='center'
              alignItems='center'
              padding={0}
              marginRight={1}
              borderRight={(theme) => `1px solid ${theme.palette.borderColor}`}
              color='var(--color-label)'
              sx={{ aspectRatio: 1 }}
            >
              $
            </Box>
          }
        />
        <SparkDropdown
          name='billingTypeID'
          label='Billing Type'
          placeholder='Please select'
          size={6}
          containerStyle={{ visibility: price > 0 ? 'inherit' : 'hidden' }}
          children={billingOptions}
          required={true}
        />
        {price > 0 && (
          <SparkTextField
            name='trialUses'
            label='Trial Uses'
            placeholder='Up to 5'
            type='number'
            size={12}
            maxNumber={5}
            helpText='Allow users to try before they buy'
          />
        )}
      </Grid>
      <Divider
        sx={{ width: '100%', marginTop: '20px', marginBottom: '20px' }}
      />
      <SectionHeader headerText='Public Info' />
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <SparkTextField
            name='supportUrl'
            label='Support URL'
            placeholder='https://'
            size={12}
            showCounter={true}
            maxNumber={50}
            required={true}
          />
        </Grid>
        <Grid item xs={6}>
          <SparkTextField
            label='Privacy Policy URL'
            name='privacyPolicyUrl'
            placeholder='https://'
            size={12}
            showCounter={true}
            maxNumber={50}
            required={true}
          />
        </Grid>
        <Grid item xs={6}>
          <SparkTextField
            label='Marketing URL'
            name='marketingUrl'
            placeholder='https://'
            size={12}
            showCounter={true}
            maxNumber={50}
            required={true}
          />
        </Grid>
        <Grid item xs={6}>
          <SparkTextField
            label='Copyright URL'
            name='copyrightUrl'
            placeholder='https://'
            size={12}
            showCounter={true}
            required={true}
            maxNumber={50}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default PrivacyInfoBillingContent;
